    const selectors = {
    readMoreBtn: document.querySelectorAll('[data-readMoreBtn]')
  };
  class templateWholesaleJS {
    constructor() {
        this.readMore();
    }

    // Read More and Read Less
    readMore(){
        selectors.readMoreBtn.forEach(element => {
            let ContainerH = element.closest('.ingredients-wrapper').querySelector('[data-readmorecontainer]').clientHeight;
            let ContaineruH = element.closest('.ingredients-wrapper').querySelector('[data-readmorecontainer]').querySelector('ul').clientHeight;
            if (ContainerH > ContaineruH){
                console.log('bhargav');
                element.classList.remove('d-inline-block');
                element.classList.add('d-none');
            }
            element.addEventListener('click', (e)=>{
                e.preventDefault();
                let currentTarget = e.target;
                if(currentTarget.closest('.ingredients-wrapper').querySelector('[data-readmorecontainer]').classList.contains('open')){
                    currentTarget.closest('.ingredients-wrapper').querySelector('[data-readmorecontainer]').classList.remove('open');
                    currentTarget.innerHTML = 'Read More'
                }else{
                    currentTarget.closest('.ingredients-wrapper').querySelector('[data-readmorecontainer]').classList.add('open');
                    currentTarget.innerHTML = 'Read Less'
                }
            });
        });

    }
}

typeof templateWholesaleJS !== 'undefined' && new templateWholesaleJS();

 